import gql from 'graphql-tag';

export default fields => gql`
mutation ($input: UpdateWebsiteInput!) {
    updateWebsite (input: $input) {
        __typename
        ${[...['id', 'name'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Websites/UpdateMutation.js